import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls the availability of the new retailer experience for Fulfilled by Faire on clients
 */
export const FULFILLED_BY_FAIRE_RETAILER_EXPERIENCE_250710 =
  'FULFILLED_BY_FAIRE_RETAILER_EXPERIENCE_250710' as SettingConst<
    'FULFILLED_BY_FAIRE_RETAILER_EXPERIENCE_250710',
    boolean,
    'RETAILER' | 'RETAILER_IOS' | 'RETAILER_ANDROID' | 'VISITOR_WEB'
  >;
